import React, { Component } from 'react';
import { Modal, FormControl, FormGroup, ControlLabel, Row, Col } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";


class AdminUserFormModal extends Component {

    static contextTypes = { api: PropTypes.object, notifier: PropTypes.object };

    constructor(props, context) {
        super(props);

        if (props.defaultValues)
            this.state = { form: AdminUserFormModal.entityToForm(props.defaultValues) };
        else
            this.state = { form: {} };

    }

    /* --- Data treatment methods --- */

    static entityToForm(entity = {}) {

        const form = { ...entity, username: entity.user && entity.user.username };
        return form;
    }

    static formToEntity(form) {

        const entity = { ...form };

        return entity;
    }

    /* --- Form Methods --- */

    onFormChange = ({ target }) => {

        const form = { ...this.state.form, [target.name]: target.value };
        this.setState({ form });
    };

    onFormChangeCaps = ({ target }) => {

        const form = { ...this.state.form, [target.name]: target.value.toUpperCase() };
        this.setState({ form });
    };

    getFormValue = (name) => {
        return this.state.form[name] ? this.state.form[name] : '';
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ form: { ...this.state.form } }, () => {
            if (this.props.onSubmit)
                this.props.onSubmit(AdminUserFormModal.formToEntity(this.state.form));
        });
    };


    render() {
        return (
            <Modal
                show={true}
                onHide={this.props.onHide}
                className='PersonFormModal'>

                <form onSubmit={this.onSubmit}>

                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.editing ? 'Editar' : 'Nuevo'} usuario</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <FormGroup controlId='name'>
                            <ControlLabel>* Nombre</ControlLabel>
                            <FormControl
                                placeholder='Nombre'
                                name='name'
                                value={this.getFormValue('name')}
                                onChange={this.onFormChangeCaps}
                                required
                            />
                        </FormGroup>

                        <Row>
                            <Col md={6}>
                                <FormGroup controlId='patLastName'>
                                    <ControlLabel>* Apellido paterno</ControlLabel>
                                    <FormControl
                                        placeholder='Apellido paterno'
                                        name='patLastName'
                                        value={this.getFormValue('patLastName')}
                                        onChange={this.onFormChangeCaps}
                                        required
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup controlId='matLastName'>
                                    <ControlLabel>Apellido materno</ControlLabel>
                                    <FormControl
                                        placeholder='Apellido materno'
                                        name='matLastName'
                                        value={this.getFormValue('matLastName')}
                                        onChange={this.onFormChangeCaps}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup controlId='username'>
                                    <ControlLabel>* Nombre de usuario</ControlLabel>
                                    <FormControl
                                        placeholder='Nombre de usuario'
                                        name='username'
                                        value={this.getFormValue('username')}
                                        onChange={this.onFormChange}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                {this.props.editing ?
                                    <FormGroup controlId='password'>
                                        <ControlLabel>Contraseña</ControlLabel>
                                        <FormControl
                                            placeholder='Contraseña'
                                            name='password'
                                            value={this.getFormValue('password')}
                                            onChange={this.onFormChange}
                                        />
                                    </FormGroup> :
                                    <FormGroup controlId='password'>
                                        <ControlLabel>* Contraseña</ControlLabel>
                                        <FormControl
                                            placeholder='Contraseña'
                                            name='password'
                                            value={this.getFormValue('password')}
                                            onChange={this.onFormChange}
                                            required
                                        />
                                    </FormGroup>
                                }
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type='button' onClick={this.props.onHide}
                            className='btn btn-danger pull-left'>Cancelar
                        </button>
                        <button type='submit' className='btn btn-success' disabled={this.props.disabled}>Guardar
                        </button>
                    </Modal.Footer>

                </form>
            </Modal>);
    }
}


const mapStateToProps = () => {
    return {}
};

export default connect(mapStateToProps)(AdminUserFormModal);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/AdminUsers/components/AdminUserFormModal/index.js